export default {
  'app.settings.menuMap.basic': 'Paramètres de base',
  'app.settings.menuMap.security': 'Paramètres de sécurité',
  'app.settings.menuMap.binding': 'Liaison de compte',
  'app.settings.menuMap.notification': 'Notification de nouveaux messages',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': "Changer d'avatar",
  'app.settings.basic.email': 'E-mail',
  'app.settings.basic.email-message': 'Veuillez saisir votre e-mail !',
  'app.settings.basic.nickname': 'Pseudo',
  'app.settings.basic.nickname-message': 'Veuillez saisir votre pseudo !',
  'app.settings.basic.profile': 'Profil personnel',
  'app.settings.basic.profile-message': 'Veuillez saisir votre profil personnel !',
  'app.settings.basic.profile-placeholder': 'Courte présentation de vous-même',
  'app.settings.basic.country': 'Pays/Région',
  'app.settings.basic.country-message': 'Veuillez saisir votre pays !',
  'app.settings.basic.geographic': 'Province ou ville',
  'app.settings.basic.geographic-message': 'Veuillez saisir vos informations géographiques !',
  'app.settings.basic.address': 'Adresse',
  'app.settings.basic.address-message': 'Veuillez saisir votre adresse !',
  'app.settings.basic.phone': 'Numéro de téléphone',
  'app.settings.basic.phone-message': 'Veuillez saisir votre numéro de téléphone !',
  'app.settings.basic.update': 'Mettre à jour les informations',
  'app.settings.security.strong': 'Fort',
  'app.settings.security.medium': 'Moyen',
  'app.settings.security.weak': 'Faible',
  'app.settings.security.password': 'Mot de passe du compte',
  'app.settings.security.password-description': 'Niveau actuel de sécurité du mot de passe',
  'app.settings.security.phone': 'Téléphone de sécurité',
  'app.settings.security.phone-description': 'Téléphone lié',
  'app.settings.security.question': 'Question de sécurité',
  'app.settings.security.question-description':
    "La question de sécurité n'est pas définie. Une politique de sécurité efficace peut protéger votre compte.",
  'app.settings.security.email': 'E-mail de sauvegarde',
  'app.settings.security.email-description': 'E-mail lié',
  'app.settings.security.mfa': 'Appareil MFA',
  'app.settings.security.mfa-description':
    'Appareil MFA non lié. Une fois lié, il pourra être confirmé deux fois.',
  'app.settings.security.modify': 'Modifier',
  'app.settings.security.set': 'Définir',
  'app.settings.security.bind': 'Lier',
  'app.settings.binding.taobao': 'Lier Taobao',
  'app.settings.binding.taobao-description': 'Compte Taobao actuellement non lié',
  'app.settings.binding.alipay': 'Lier Alipay',
  'app.settings.binding.alipay-description': 'Compte Alipay actuellement non lié',
  'app.settings.binding.dingding': 'Lier DingTalk',
  'app.settings.binding.dingding-description': 'Compte DingTalk actuellement non lié',
  'app.settings.binding.bind': 'Lier',
  'app.settings.notification.password': 'Mot de passe du compte',
  'app.settings.notification.password-description':
    "Les messages d'autres utilisateurs seront notifiés sous forme de lettre de station",
  'app.settings.notification.messages': 'Messages système',
  'app.settings.notification.messages-description':
    'Les messages système seront notifiés sous forme de lettre de la station',
  'app.settings.notification.todo': 'Notification de tâche à accomplir',
  'app.settings.notification.todo-description':
    'La liste de tâches à accomplir sera notifiée sous forme de lettre de la station',
  'app.settings.open': 'Ouvrir',
  'app.settings.close': 'Fermer',
};
